import React from 'react';
import { tl } from 'common/services/i18nService';
import * as styles from 'common/components/header/Header.scss';
import { UserObject } from 'common/store/session/reducer';
import { Menu, Icon } from 'semantic-ui-react';
import EvaluatorPopUpBox from 'common/components/evaluatorPopUpBox';

interface CoGradersListProps {
    graders: UserObject[];
    worflowStateText?: string;
}

export const CoGradersList: React.FC<CoGradersListProps> = ({ graders = [], worflowStateText }) => {
    const EvaluatorsData = graders && graders.map((item) => {
        return (
            <EvaluatorPopUpBox
                evaluatorName={`${item.firstName} ${item.lastName}`}
                email={item.email}
                lastLogin={item.lastLogin}
                workflowState={worflowStateText}
            />
        );
    });

    return (
        <Menu vertical className="candidateActionsPopUp">
            <Menu.Header
                className={styles.actionTitle}
            >
                <span>
                    <Icon name="clock outline" flipped="horizontally" />
                    {tl('grading.header.awaitingConfirmation')}
                </span>
            </Menu.Header>
            <div className={styles.popUpBox}>
                {EvaluatorsData}
            </div>
        </Menu>
    );
};

export default CoGradersList;
